<template>
  <container>
    <div class="w-full flex flex-col mt-16">
      <title-component title="Quais os benefícios pós tratamento?"
                       sub-title="Descubra como esse tratamento inovador pode eliminar sua dor e devolver sua qualidade de vida"
      />
      <div class="w-full flex mt-12 flex-col lg:flex-row justify-between items-center mx-auto">
        <div class="w-full flex flex-row gap-x-4 mb-8 lg:mb-0 lg:w-6/12">
          <div class="flex flex-col gap-4">
            <img src="../../../public/824.webp" alt="Fascias benefícios" width="300" height="300" class="rounded-lg"/>
            <img src="../../../public/1017.webp" alt="Fascias benefícios" width="300" height="300" class="rounded-lg"/>
            <img src="../../../public/1245.webp" alt="Fascias benefícios" width="300" height="300" class="rounded-lg"/>
          </div>
          <div class="flex flex-col gap-4">
            <img src="../../../public/12345.webp" alt="Fascias benefícios" width="300" height="300" class="rounded-lg"/>
            <img src="../../../public/29783.webp" alt="Fascias benefícios" width="300" height="300" class="rounded-lg"/>
            <img src="../../../public/3479.webp" alt="Fascias benefícios"  width="300" height="300" class="rounded-lg"/>
          </div>
        </div>
       <div class="w-full lg:w-6/12">
         <ul
             class="flex flex-col"
             v-for="(benefit, index) in benefits" :key="index"
         >
           <li class="pb-4">
             <div class="flex flex-row gap-1">
               <div
                   class="inline-flex items-center justify-center rounded-full p-2 ">
                 <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" height="24" viewBox="0 0 512 512" width="24"
                      class="fill-[#00DBDE]">
                   <path clip-rule="evenodd"
                         d="m404.23 256.006c0-81.742-66.478-148.245-148.25-148.245-81.723 0-148.25 66.503-148.25 148.245 0 81.738 66.527 148.25 148.25 148.25 81.773.001 148.25-66.512 148.25-148.25zm51.833 0c0 110.313-89.77 200.053-200.082 200.053-110.313 0-200.033-89.74-200.033-200.053 0-110.312 89.72-200.057 200.033-200.057 110.312 0 200.082 89.745 200.082 200.057zm-449.898 52.572c-6.748-5.963-8.097-15.454-3.349-23.072l26.841-42.816c5.398-8.617 6.797-18.344 4.048-28.131l-13.695-48.632c-2.4-8.657 1.549-17.374 9.696-21.203l45.685-21.518c9.197-4.333 15.645-11.761 18.644-21.478l14.795-48.308c2.599-8.597 10.697-13.776 19.593-12.601l50.083 6.608c10.097 1.33 19.543-1.44 27.291-8.007l38.537-32.639c6.848-5.803 16.445-5.803 23.292 0l38.587 32.639c7.747 6.568 17.194 9.337 27.291 8.007l50.083-6.608c8.897-1.175 16.944 4.008 19.594 12.601l14.795 48.308c2.999 9.717 9.397 17.149 18.593 21.478l45.735 21.518c8.147 3.829 12.096 12.546 9.697 21.203l-13.695 48.633c-2.749 9.792-1.35 19.519 4.048 28.131l26.791 42.816c4.798 7.617 3.449 17.109-3.299 23.072l-37.787 33.519c-7.597 6.752-11.696 15.689-11.796 25.851l-.6 50.523c-.1 8.992-6.398 16.234-15.244 17.609l-49.933 7.777c-10.047 1.564-18.294 6.878-23.892 15.37l-27.84 42.181c-4.948 7.497-14.145 10.197-22.342 6.558l-46.185-20.443c-9.303-4.12-19.115-4.129-28.44 0l-46.184 20.443c-8.247 3.639-17.444.94-22.393-6.558l-27.791-42.181c-5.598-8.492-13.845-13.805-23.892-15.37l-49.933-7.777c-8.897-1.375-15.145-8.617-15.245-17.609l-.6-50.523c-.1-10.162-4.198-19.099-11.796-25.851zm249.815-217.881c91.169 0 165.344 74.155 165.344 165.309 0 91.159-74.175 165.314-165.344 165.314-91.119 0-165.294-74.155-165.294-165.314 0-91.154 74.175-165.309 165.294-165.309zm-182.988 165.309c0-100.901 82.122-182.988 182.988-182.988 100.916 0 182.988 82.087 182.988 182.988 0 100.906-82.072 182.988-182.988 182.988-100.866.001-182.988-82.081-182.988-182.988zm269.959-46.359-104.765 104.785c-3.294 3.309-8.72 3.341-12.046 0l-57.081-57.086c-3.349-3.329-3.349-8.732 0-12.066 3.299-3.329 8.697-3.329 12.046 0l51.033 51.053 98.767-98.752c3.349-3.329 8.747-3.329 12.046 0 3.349 3.334 3.349 8.737 0 12.066z"
                         fill-rule="evenodd"></path>
                 </svg>
               </div>
               <h4 class="flex flex-col items-start text-lg font-medium leading-8 lg:items-center md:flex-row text-slate-700">
                    <span class="flex-1 text-sm font-bold lg:text-lg">{{ benefit }}
                    </span>
               </h4>
             </div>
           </li>
         </ul>
       </div>

      </div>

    </div>
  </container>
</template>
<script>
import Container from "@/components/partials/Container.vue";
import TitleComponent from "@/components/TitleComponent.vue";

export default {
  name: "FasciasBenefits",
  components: {TitleComponent, Container},
  data() {
    return {
      benefits: [
        "Mais disposição",
        "Intestino regular",
        "Praticar seu esporte sem dor",
        "Corrigir e melhorar a postura",
        "Diminuir ansiedade e estresse",
        "Não sentir dor para fazer suas tarefas do dia a dia",
        "Melhorar a respiração concentração",
        "Adequado para gestantes e idosos",
        "Melhorar a qualidade do sono",
        "Melhorar a qualidade de vida",
        "Caminhar/ficar sentado sem dor"
      ]
    }
  }
}
</script>
